import React, { useEffect } from 'react';
import logo from '../../IMG/touaki.png';
import { Link } from 'react-router-dom';
import { useBusinessAuth } from '../../Middleware/context/BusinessContext';

function DashboardHeader() {
  const { companyProfile } = useBusinessAuth();





  return (
    <div>
      <nav className="relative bg-gray-800">
        <div className="mx-auto max-w-7xl px-2 sm:px-6 lg:px-8">
          <div className="relative flex h-16 items-center justify-between">

            {/* MOBILE BUTTON */}
            <div className="absolute inset-y-0 left-0 flex items-center sm:hidden">
              <button
                type="button"
                className="relative inline-flex items-center justify-center rounded-md p-2 text-gray-400 hover:bg-white/5 hover:text-white focus:outline-none"
              >
                <span className="sr-only">Open main menu</span>
                <svg
                  className="size-6"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  viewBox="0 0 24 24"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5" />
                </svg>
              </button>
            </div>

            {/* LOGO + MENU */}
            <div className="flex flex-1 items-center justify-center sm:items-stretch sm:justify-start">
              <div className="flex shrink-0 items-center">
                <Link to="/Home">
                  <img
                    src={companyProfile?.img || logo}
                    alt="Company Logo"
                    className="h-10 w-10 rounded-full object-cover"
                  />
                </Link>
              </div>

              {/* DESKTOP MENU */}
              <div className="hidden sm:ml-6 sm:block">
                <div className="flex space-x-4">

                  <Link
                    to="/Home"
                    className="rounded-md bg-gray-900 px-3 py-2 text-sm font-medium text-white"
                  >
                    {companyProfile?.nome || "Dashboard"}
                  </Link>

                  <a href='/MNGMT/Business/Facturas' className="rounded-md px-3 py-2 text-sm font-medium text-gray-300 hover:bg-white/5 hover:text-white">
                    Facturas
                  </a>

                  <a className="rounded-md px-3 py-2 text-sm font-medium text-gray-300 hover:bg-white/5 hover:text-white">
                    Stock
                  </a>

                  <a className="rounded-md px-3 py-2 text-sm font-medium text-gray-300 hover:bg-white/5 hover:text-white">
                    Report
                  </a>

                </div>
              </div>
            </div>

            {/* RIGHT SIDE BUTTONS */}
            <div className="absolute inset-y-0 right-0 flex items-center pr-2 sm:static sm:inset-auto sm:ml-6 sm:pr-0">

              {/* Notifications Icon */}
              <button
                type="button"
                className="relative rounded-full p-1 text-gray-400 hover:text-white focus:outline-none"
              >
                <span className="sr-only">View notifications</span>
                <svg
                  className="size-6"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M14.857 17.082a23.848 23.848 0 0 0 5.454-1.31A8.967 8.967 0 0 1 18 9.75V9A6 6 0 0 0 6 9v.75a8.967 8.967 0 0 1-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 0 1-5.714 0m5.714 0a3 3 0 1 1-5.714 0"
                  />
                </svg>
              </button>

              {/* USER MENU PLACEHOLDER */}
              <div className="ml-3">
                <button className="relative flex rounded-full focus:outline-none">
                  <img
                    className="size-8 rounded-full bg-gray-800"
                    src={companyProfile?.img || logo}
                    alt="User"
                  />
                </button>
              </div>
            </div>

          </div>
        </div>

        {/* MOBILE MENU */}
        <div className="sm:hidden hidden">
          <div className="space-y-1 px-2 pt-2 pb-3">
            <a className="block rounded-md bg-gray-900 px-3 py-2 text-base font-medium text-white">
              Dashboard
            </a>
            <a className="block rounded-md px-3 py-2 text-base font-medium text-gray-300 hover:bg-white/5 hover:text-white">
              Team
            </a>
            <a className="block rounded-md px-3 py-2 text-base font-medium text-gray-300 hover:bg-white/5 hover:text-white">
              Projects
            </a>
            <a className="block rounded-md px-3 py-2 text-base font-medium text-gray-300 hover:bg-white/5 hover:text-white">
              Calendar
            </a>
          </div>
        </div>
      </nav>
    </div>
  );
}

export default DashboardHeader;